const CAMPAIGN_PARAM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
] as const;

type CampaignParamKey = typeof CAMPAIGN_PARAM_KEYS[number];

export type CampaignTraits = Partial<Record<CampaignParamKey, string>>;

export const getCampaignTraits = (search: string): CampaignTraits => {
  const params = new URLSearchParams(search);

  return CAMPAIGN_PARAM_KEYS.reduce<CampaignTraits>((traits, key) => {
    const value = params.get(key)?.trim();
    if (!value) {
      return traits;
    }
    return { ...traits, [key]: value };
  }, {});
};
